export class GetCUPPgUnRegularPlanCopyToInput{
    Years: string = ''
    DeptNo: string = ''
    TeamNo: string = ''
    AcadCourseNo: string = ''
    TargetYears: string = ''
    TargetDeptNo: string = ''
    TargetTeamNo: string = ''
    TargetAcadCourseNo: string = ''
}